import { useEffect } from "react";
import { handleData } from "../../api";
import AdminOpenTaak from "./AdminOpenTaak";
import AdminVoltooideTaak from "./AdminVoltooideTaak";
import AdminBevestigdeTaak from "./AdminBevestigdeTaak";
import AdminNietBevestigdeTaak from "./AdminNietBevestigdeTaak";

import { useAdminActiviteiten } from "../../utils/adminActiviteiten";
import { useAdminUsers } from "../../utils/adminUsers";


const AdminAanmeldingen = () => {

    const act = useAdminActiviteiten();
    const usr = useAdminUsers();

    const openTaken = act.adminOpenTaken;
    const nietBevestigdeTaken = act.adminNietBevestigdeTaken;
    const bevestigdeTaken = act.adminBevestigdeTaken;
    const voltooideTaken = act.adminVoltooideTaken;

    const users = usr.adminUsers;


    // load data on first render
    const loadingData = () => {
        act.loadAdminActiviteiten();
        usr.loadAdminUsers();
        
    };

    useEffect(() => {
        loadingData();
    },[]);


    const handleBevestiging = async (taakID, activiteitID) =>{
        const path = `activiteiten/${activiteitID}/taken/${taakID}`;
        const input = {
            'taken.$.bevestigd': true
        }
        const data = {
            method: 'PATCH',
            path: path,
            input: input
        }
        const bevestigVrijwilliger = await handleData(data);
        act.loadAdminActiviteiten();
    }

    const verwijderBevestiging = async (taakID, activiteitID) =>{
        const path = `activiteiten/${activiteitID}/taken/${taakID}`;
        const input = {
            'taken.$.bevestigd': false
        }
        const data = {
            method: 'PATCH',
            path: path,
            input: input
        }
        const bevestigVrijwilliger = await handleData(data);
        act.loadAdminActiviteiten();
    }

    const handleVerwijdering = async (taakID, activiteitID) =>{
        const path = `activiteiten/${activiteitID}/taken/${taakID}`;
        const input = {
            'taken.$.vrijwilliger': null,
            'taken.$.vrijwilligerOpmerking': null,
            'taken.$.bevestigd': false,
            'taken.$.aanvangstijd': null,
            'taken.$.vrijwilligersInfo': null,
            'taken.$.vrijwilligervoltooid': false

        }
        const data = {
            method: 'PATCH',
            path: path,
            input: input
        }
        const verwijderVrijwilliger = await handleData(data);
        act.loadAdminActiviteiten();
    }

    return (
        <div className="adminAanmeldingenSection">
            <h2>Vrijwilligers aanmeldingen voor activiteiten </h2>
            <div>
                <div className="adminAanmeldingenContainer">
                <h3>Nog niet bevestigde vrijwilligers aanmeldingen</h3>
                <table className="adminAanmeldingen nietBevestigd">
                    <thead>
                        <tr>
                            <td>Datum</td>
                            <td>Activiteit</td>
                            <td>Vrijwilligerstaak</td>
                            <td>Dagdeel</td>
                            <td>Vrijwilliger</td>
                            <td>Contact</td>
                            <td>Bevestig aanmelding</td>
                            <td>Verwijder aanmelding</td>
                        </tr>
                    </thead>
                    <tbody>
                        {nietBevestigdeTaken && nietBevestigdeTaken.map(item => <AdminNietBevestigdeTaak 
                            key={item.taakID}
                            taak = {item}
                            handleBevestiging={handleBevestiging}
                            handleVerwijdering={handleVerwijdering}
                        />
                        )} 
                    </tbody>
                </table>

                </div>

                <div className="adminAanmeldingenContainer">
                <h3>Bevestigde vrijwilligers aanmeldingen</h3>
                <table className="adminAanmeldingen bevestigd">
                    <thead>
                        <tr>
                            <td>Datum</td>
                            <td>Activiteit</td>
                            <td>Vrijwilligerstaak</td>
                            <td>Dagdeel</td>
                            <td>Vrijwilliger</td>
                            <td>Contact</td>
                            <td>Verwijder bevestiging</td>
                            <td>Aanvangstijd</td>
                            <td>+</td>
                            <td>Info voor vrijwilliger</td>
                            <td>+</td>
                        </tr>
                    </thead>
                    <tbody>
                        {bevestigdeTaken && bevestigdeTaken.map(item => <AdminBevestigdeTaak 
                            key={item.taakID}
                            taak = {item}
                            users={users} 
                            loadingData={loadingData}
                            verwijderBevestiging={verwijderBevestiging}
                        />
                        )} 
                    </tbody>
                </table>

                </div>


                <div className="adminAanmeldingenContainer">
                    <h3>Open taken (nog geen aanmeldingen)</h3>
                    <table className="adminAanmeldingen open">
                        <thead>
                            <tr>
                                <td>Datum</td>
                                <td>Activiteit</td>
                                <td>Vrijwilligerstaak</td>
                                <td>Dagdeel</td>
                                <td>Vrijwilliger toevoegen</td>
                                <td>Selecteer vrijwilliger</td>
                                <td>Bevestig selectie</td>
                            </tr>
                        </thead>
                        <tbody>
                            {openTaken && openTaken.map(item => <AdminOpenTaak 
                                key={item.taakID} 
                                taak={item} 
                                users={users} 
                                loadingData={loadingData}
                            />)
                            } 
                        </tbody>
                    </table>
                </div>

                <div className="adminAanmeldingenContainer">
                    <h3>Voltooide activiteiten</h3>
                    <table className="adminAanmeldingen voltooid">
                        <thead>
                            <tr>
                                <td>Datum</td>
                                <td>Activiteit</td>
                                <td>Vrijwilligerstaak</td>
                                <td>Dagdeel</td>
                                <td>Vrijwilliger toevoegen</td>
                                <td>Vrijwilliger</td>
                                <td>Bevestig toegevoegde vrijwilliger</td>
                                <td>Bevestig deelname als vrijwilliger</td>
                                <td>
                                    Bevestigd
                                </td>
                                <td>Verwijder vrijwilliger</td>

                            </tr>
                        </thead>
                        <tbody>
                            {voltooideTaken && voltooideTaken.map(item => <AdminVoltooideTaak 
                                key={item.taakID} 
                                taak={item} 
                                users={users} 
                                loadingData={loadingData}
                                handleVerwijdering={handleVerwijdering}
                            />)
                            } 
                        </tbody>
                    </table>
                </div>

                
            </div>

        </div>
    );
}

export default AdminAanmeldingen;